<template>
  <sui-modal class="wrapper" size="small" v-model="visible" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Update project
    </sui-modal-header>
    <sui-modal-content>
      <sui-form :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <FormProject v-model="entity" :mode="mode" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button-group>
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors || badRenaming" @click="submit()" data-goal="UPDATE_PROJECT_TRY">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </sui-button-group>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Success
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep'
  import ModalForm from '@/mixins/ModalForm'
  import FormProject from '@/components/forms/Project'
  import utils from '@/utils'

  export default {
    name: 'ModalUpdateProject',
    mixins: [
      ModalForm,
    ],
    components: {
      FormProject,
    },
    data() {
      return {
        newMode: 'updating',
      }
    },
    computed: {
      mode() {
        return this.newMode || 'updating'
      },
      badRenaming() {
        const changes = this.entity.getChanges()
        return (this.mode === 'renaming') && !(changes && changes.name)
      },
    },
    methods: {
      open(entity, newMode) {
        this.visible = true
        this.newMode = newMode
        this.entity = cloneDeep(entity)
      },
      onSuccess() {
        this.close()
        utils.reachGoal('UPDATE_PROJECT_SUCCESS')
      },
      onFail() {
        utils.reachGoal('UPDATE_PROJECT_FAIL')
      },
    },
    created() {
      this.$modals.updateProject = this
    },
  }
</script>
